export const PRIO_CLS = {
  critical: "bg-rose-50 text-rose-700 border-rose-200",
  high: "bg-amber-50 text-amber-700 border-amber-200",
  medium: "bg-sky-50 text-sky-700 border-sky-200",
  low: "bg-slate-50 text-slate-600 border-slate-200",
};

export const RUN_CLS = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  no_match: "bg-slate-50 text-slate-600 border-slate-200",
  partial: "bg-amber-50 text-amber-700 border-amber-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
  running: "bg-sky-50 text-sky-700 border-sky-200",
};

export const fmtWhen = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const relWhen = (iso) => {
  if (!iso) return "—";
  const diff = new Date(iso).getTime() - Date.now();
  const m = Math.round(Math.abs(diff) / 60000);
  const txt = m < 1 ? "now" : m < 60 ? `${m}m` : m < 1440 ? `${Math.round(m / 60)}h` : `${Math.round(m / 1440)}d`;
  return diff >= 0 ? `in ${txt}` : `${txt} ago`;
};

export const condText = (c, ops) => `${c.field} ${ops?.[c.op] || c.op}${["empty", "not_empty"].includes(c.op) ? "" : ` ${Array.isArray(c.value) ? c.value.join(", ") : c.value}`}`;

export const emptyRule = () => ({
  name: "", description: "", trigger: { type: "quotation", params: {} }, conditions: [], actions: [],
  owner_email: "", priority: "medium", enabled: false, interval_minutes: 60, cooldown_days: 7, max_per_run: 100,
});
